import { render, staticRenderFns } from "./ContractText.vue?vue&type=template&id=160a4bf6&"
import script from "./ContractText.vue?vue&type=script&lang=js&"
export * from "./ContractText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports